import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

function Navbar() {
  const menuItems = [
    { name: "Home", path: "/" },
    { name: "Service", path: "service" },
    { name: "Product", path: "product" },
    { name: "Blog", path: "blog" },
    { name: "Career", path: "career" },
    { name: "About us", path: "about-us" },
  ];

  return (
    <nav className="absolute top-0 left-0 z-20 flex items-center justify-between w-full px-24 py-9 text-textColor font-IBM">
      <div className="flex items-center space-x-8">
        <Link to="/">
          <motion.div
            href="/"
            className="text-lg font-semibold text-white cursor-pointer"
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0 }}
          >
            eCyberNest
          </motion.div>
        </Link>

        <div className="flex space-x-8 font-medium text-nav">
          {menuItems.map((item, index) => (
            <Link
              key={item.name}
              to={item.path}
              className="flex font-medium text-nav"
            >
              <motion.a
                className="cursor-pointer hover:text-white"
                initial={{ y: -50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{
                  type: "spring",
                  stiffness: 80,
                  damping: 10,
                  delay: (index + 1) * 0.1,
                }}
              >
                {item.name}
              </motion.a>
            </Link>
          ))}
        </div>
      </div>

      <motion.div
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0 }}
        className="flex items-center p-px text-xs cursor-pointer bg-gradient-to-r from-gray-300 to-gray-600 rounded-3xl"
      >
        <div className="text-gray-200 bg-black rounded-[calc(1.5rem-1px)] px-6 py-3">
          Get Started
        </div>
      </motion.div>
    </nav>
  );
}

export default Navbar;
